import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { CH_FACET_ID } from "../../models/constants"
import { Facet } from "../../models/facet.model"
import { BaseNode, CHNode } from "../../models/node.model"
import { SearchInfoModel } from "../../models/searchInfo.model"
import { BrowsingService } from "../../services/browsing.service"
import { FacetingService } from "../../services/faceting.service"
import { SearchingService } from "../../services/searching.service"
import { EduComponent } from "../../utils/eduComponent"
import { AddOnViewService } from "../../services/add-on-view.service"

@Component({
    selector: "app-facets",
    templateUrl: "./facets.component.html",
    styleUrls: ["./facets.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class FacetsComponent extends EduComponent implements OnInit, OnDestroy {
    @Input() public syncFacets: boolean = false
    @Input() public premiumCollectionSearch: boolean = false

    grades: string[]
    mediaTypes: string[]
    chFacetInfo: any = {}
    nestedFacetsInfo = []
    isAddonView: boolean

    constructor(
        protected browsingService: BrowsingService,
        protected facetingService: FacetingService,
        protected searchingService: SearchingService,
        protected route: ActivatedRoute,
        protected addOnService: AddOnViewService
    ) {
        super()
    }

    public ngOnInit() {
        this.grades = this.facetingService.grades
        this.mediaTypes = this.facetingService.media_type
        this.subscribeToNodeUpdates()
        this.subscribeToFacetsInfo()
    }

    private subscribeToNodeUpdates() {
        this.isAddonView = this.addOnService.isAddonView
        this.chFacetInfo = {}
        this.nestedFacetsInfo = []
        if (this.premiumCollectionSearch) {
            this.addSub(
                // CH facet setup
                this.searchingService.searchInfo.subscribe((searchInfo: SearchInfoModel) => {
                    if (searchInfo.chSectionName) {
                        this.facetingService.setupNestedFacet(
                            CH_FACET_ID,
                            searchInfo.chSectionName,
                            searchInfo.chFilter
                        )
                    }
                    searchInfo.customFilterObjects.forEach((cf) => {
                        const nodes: BaseNode[] = cf.children.map((obj) => BaseNode.fromObject(obj))
                        this.facetingService.setupNestedFacet(
                            cf.filter_id,
                            cf.filter_name,
                            nodes,
                            true
                        )
                    })
                })
            )
        } else {
            this.addSub(
                this.browsingService.tree.subscribe((disciplines: CHNode[]) => {
                    this.facetingService.setupNestedFacet(CH_FACET_ID, "Subject", disciplines, true)
                })
            )
        }
    }

    private subscribeToFacetsInfo() {
        this.addSub(
            // Custom facets setup
            this.facetingService.nestedFacetsChanged.subscribe(
                (facets: Record<string, Facet<BaseNode>>) => {
                    this.nestedFacetsInfo = Object.values(facets)
                        .filter((f) => f.id !== CH_FACET_ID)
                        .map((f) => ({ id: f.id, name: f.name }))
                    this.chFacetInfo = facets[CH_FACET_ID]
                        ? { id: CH_FACET_ID, name: facets[CH_FACET_ID].name }
                        : {}
                }
            )
        )
    }

    public onClearClick() {
        this.facetingService.clearFilters(this.route)
    }
}
